<div #overlay class="overlay">
    <div class="content center-content">
        <div class="column-flex">
            <mat-icon
                svgIcon="profile-cross"
                class="icon"
                data-cy="vessel-folder-req-access-remove-editor-conf-modal-icon" />
            <div class="title" data-cy="vessel-folder-req-access-remove-editor-conf-modal-header">
                {{ 'remove-access.dialog.form.title' | translate }}
            </div>
            <div class="subtitle" data-cy="vessel-folder-req-access-remove-editor-conf-modal-body">
                {{ 'remove-access.dialog.form.subtitle' | translate }}
            </div>

            <div class="buttons-container">
                <div
                    class="cancel button"
                    data-cy="vessel-folder-req-access-remove-editor-conf-modal-cancel-btn"
                    (click)="cancel()">
                    {{ 'remove-access.dialog.form.button.cancel' | translate }}
                </div>
                <div
                    class="button"
                    data-cy="vessel-folder-req-access-remove-editor-conf-modal-confirm-btn"
                    (click)="remove()">
                    {{ 'remove-access.dialog.form.button.confirm' | translate }}
                </div>
            </div>
        </div>
    </div>
</div>
